import { RegisterUserModel } from './../../../../../core/auth/_models/registerUserModel';
import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Subject, of } from 'rxjs';
import { AuthNoticeService, AuthService, User, Register, Login, UserLoaded } from '../../../../../core/auth';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../../core/reducers';
import { ConfirmPasswordValidator } from '../../../shared/validators/confirm-password.validator'
import { tap, takeUntil, finalize, catchError } from 'rxjs/operators';
import { SharedObject } from '../../../shared/sharedObject';
import { RoleService } from '../../../shared/services/roleService';

@Component({
	selector: 'kt-register',
	templateUrl: './register.component.html',
	styleUrls: ['register.component.scss'],
})
export class RegisterComponent implements OnInit, OnDestroy {
	registerForm: FormGroup;
	loading = false;
	errors: any = [];
	selectedGender: number = 0;
	selectedBirthDate: Date = new Date();
	private unsubscribe: Subject<any>; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/

	/**
	 * Component constructor
	 *
	 * @param authNoticeService: AuthNoticeService
	 * @param translate: TranslateService
	 * @param router: Router
	 * @param auth: AuthService
	 * @param store: Store<AppState>
	 * @param fb: FormBuilder
	 * @param cdr
	 */
	constructor(
		private authNoticeService: AuthNoticeService,
		private translate: TranslateService,
		private router: Router,
		private auth: AuthService,
		private store: Store<AppState>,
		private fb: FormBuilder,
		private roleService: RoleService,
		private cdr: ChangeDetectorRef,
		private aRoute: ActivatedRoute,
		private authService: AuthService
	) {
		this.unsubscribe = new Subject();
	}

	ngOnInit() {
		this.router.navigateByUrl("/auth/login/otp");
		this.initRegisterForm();
	}

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
		this.loading = false;
	}

	initRegisterForm() {
		this.registerForm = this.fb.group({
			fName: ['', Validators.compose([
				Validators.required,
				Validators.minLength(2),
				Validators.maxLength(50),
				Validators.pattern(SharedObject.FarsiPattern)
			])
			],
			lName: ['', Validators.compose([
				Validators.required,
				Validators.minLength(2),
				Validators.maxLength(100),
				Validators.pattern(SharedObject.FarsiPattern)
			])
			],
			gender: ['', Validators.compose([
				Validators.required
			])
			],
			mobileNumber: ['', Validators.compose([
				Validators.required,
				Validators.minLength(11),
				Validators.maxLength(11),
				Validators.pattern(SharedObject.MobilePattern)
			]),
			],
			birthday: ['', Validators.compose([
				Validators.required,
				Validators.minLength(10),
				Validators.maxLength(10)
			]),
			],
			password: ['', Validators.compose([
				Validators.required,
				Validators.pattern(SharedObject.PasswordPattern)
			])
			],
			confirmPassword: ['', Validators.compose([
				Validators.required,
				Validators.pattern(SharedObject.PasswordPattern)
			])
			],
			agree: [false, Validators.compose([Validators.required])]
		},
			{
				validator: ConfirmPasswordValidator.MatchPassword

			});
	}


	submit() {
		const controls = this.registerForm.controls;

		if (this.registerForm.invalid) {
			Object.keys(controls).forEach(controlName =>
				controls[controlName].markAsTouched()
			);
			return;
		}
		this.loading = true;
		const model: RegisterUserModel = new RegisterUserModel();
		model.userName = controls['mobileNumber'].value.FaToEnDigits();
		model.password = controls['password'].value.FaToEnDigits();
		model.firstName = (controls['fName'].value as string).trim();
		model.lastName = (controls['lName'].value as string).trim();
		model.isMale = controls['gender'].value;
		model.birthDate = this.selectedBirthDate;
		this.auth.registerUser(model).subscribe(res => {
			this.authNoticeService.setNotice(this.translate.instant('با موفقیت ثبت گردید - در حال ورود به حساب کاربری ...'), 'success');
			this.cdr.markForCheck();
			this.auth
				.login(model.userName, model.password)
				.pipe(
					tap(res => {
						if (res) {
							const returnUser: User = new User();
							returnUser.firstName = res["result"]["firstName"];
							returnUser.lastName = res["result"]["lastName"];
							returnUser.isMale = res["result"]["isMale"];
							returnUser.username = res["result"]["username"];
							returnUser.access_token = res["result"]["access_token"];
							returnUser.refresh_token = res["result"]["refresh_token"];
							returnUser.userStatus = res["result"]["userStatus"];
							returnUser.role = res["result"]["role"];
							this.store.dispatch(
								new Login({ authToken: returnUser.access_token })
							);
							this.store.dispatch(new UserLoaded({ user: returnUser }));
							this.roleService.getAllRoles();
							let params = this.aRoute.snapshot.queryParams;
							if (params['redirectURL']) {
								let redirectURL = params['redirectURL'];
								if (redirectURL) {
									this.router.navigateByUrl(redirectURL);
								}

							} else
								this.router.navigateByUrl("/account/dashboard"); // Main page
						} else {
							this.authNoticeService.setNotice("کاربر با این مشخصات یافت نشد", "danger");
						}
					}),
					catchError(err => {
						var error = "خطای سرور";
						if (err.error.result) error = err.error.result;
						this.authNoticeService.setNotice(error, "danger");
						this.loading = false;
						this.cdr.detectChanges();
						return of([]);
					}),
					takeUntil(this.unsubscribe),
					finalize(() => {
						this.cdr.detectChanges();
					})
				)
				.subscribe();

		}, err => {
			this.authNoticeService.setNotice(this.translate.instant(err.error.result), 'danger');
			this.loading = false;
			this.cdr.markForCheck();
		}, () => {
			
			this.cdr.markForCheck();
		});
	}

	isControlHasError(controlName: string, validationType: string): boolean {

		const control = this.registerForm.controls[controlName];
		if (!control) {
			return false;
		}
		const result = control.hasError(validationType) && (control.dirty || control.touched);
		return result;
	}
}
